import i18n from './index';

export const currentLocale = () => (i18n.resolvedLanguage === 'ru' ? 'ru-RU' : 'en-US');

export function formatNumber(value, options = {}) {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return '—';
  return new Intl.NumberFormat(currentLocale(), options).format(Number(value));
}

export function formatCurrency(value, currency = 'RUB', options = {}) {
  return formatNumber(value, { style: 'currency', currency, ...options });
}

export function formatDate(value, options = {}) {
  if (value === null || value === undefined || value === '') return '—';
  const dateOnly = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = value instanceof Date ? value : new Date(dateOnly ? `${value}T00:00:00Z` : value);
  if (!Number.isFinite(date.getTime())) return '—';
  // Callers retain their existing timezone. A language preference is not a timezone.
  return new Intl.DateTimeFormat(currentLocale(), dateOnly ? { ...options, timeZone: 'UTC' } : options).format(date);
}

export function formatRelative(value, unit, options = {}) {
  return new Intl.RelativeTimeFormat(currentLocale(), { numeric: 'auto', ...options }).format(value, unit);
}
